import React from "react";

export const Loader = () => {
  return <p className="message">Loading...</p>;
};
